import Tilt from 'react-parallax-tilt';
import { isMobileOrTablet } from 'utilities/userAgent';

interface CardTiltProps {
  children: React.ReactNode;
  enabled?: boolean;
}

const isTouchDevice = isMobileOrTablet();
const CardTilt: React.FC<CardTiltProps> = ({ enabled = true, children }) => {
  if (!enabled || isTouchDevice) return <>{children}</>;
  return (
    <Tilt tiltReverse trackOnWindow perspective={5000} style={{ width: '100%' }}>
      {children}
    </Tilt>
  );
};

export default CardTilt;
